import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ICopyLeverantorsorderHeader } from "../copy-leverantorsorder.models";

export class CopyLeverantorsorderHeaderValidation {
    static init(header: ICopyLeverantorsorderHeader): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.skapa).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: "Du måste ange datum" },
                model: () => header.periodFrom,
                name: "periodFrom",
                required: true,
                verbose: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (periodTom) => !!header.periodFrom && header.periodFrom <= periodTom,
                id: 2,
                message: { text: "Till-datum måste vara större eller lika med från-datum" },
                model: () => header.periodTom,
                name: "periodTom",
                required: true,
                subscriptions: ["periodFrom"],
                verbose: true
            }
        ]);

        return context;
    }
}
